import Vue from 'vue'
import * as fns from "date-fns"

Vue.prototype.$format = fns.format
